import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { UserPlus } from "lucide-react";

export default function RegisterPage() {
  const { user, register, error } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", first_name: "", last_name: "", company: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user && user.id) return <Navigate to="/portal" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const newUser = await register(form);
    setBusy(false);
    if (newUser) navigate(newUser.role === "admin" ? "/admin" : "/portal");
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50 flex items-center" data-testid="register-page">
      <div className="mbw-container max-w-lg mx-auto w-full">
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-slate-200 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-14 h-14 rounded-xl bg-[#1A2433] flex items-center justify-center mx-auto mb-4">
              <UserPlus className="w-7 h-7 text-[#991B1B]" />
            </div>
            <h1 className="font-heading text-3xl font-bold text-[#1A2433] mb-2">Konto erstellen</h1>
            <p className="text-slate-600 text-sm">Ihr digitaler Treuhand-Schreibtisch in 1 Minute.</p>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div className="grid grid-cols-2 gap-4">
              <Field label="Vorname" required value={form.first_name} onChange={set("first_name")} testid="reg-first" />
              <Field label="Nachname" required value={form.last_name} onChange={set("last_name")} testid="reg-last" />
            </div>
            <Field label="E-Mail" type="email" required value={form.email} onChange={set("email")} testid="reg-email" />
            <Field label="Passwort (min. 8 Zeichen)" type="password" required value={form.password} onChange={set("password")} testid="reg-password" />
            <Field label="Firma (optional)" value={form.company} onChange={set("company")} testid="reg-company" />
            <Field label="Telefon (optional)" value={form.phone} onChange={set("phone")} testid="reg-phone" />

            {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-md" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="register-submit-btn">
              {busy ? "Konto wird erstellt…" : "Konto erstellen"}
            </button>
          </form>

          <div className="text-center text-sm text-slate-600 mt-6">
            Bereits Konto? <Link to="/login" className="font-semibold text-[#1A2433] hover:text-[#991B1B]">Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, required, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="block text-sm font-medium text-[#1A2433] mb-2">{label}{required && " *"}</label>
      <input
        type={type} required={required} value={value} onChange={onChange}
        className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#991B1B]"
        data-testid={testid}
      />
    </div>
  );
}
